module.exports = __webpack_public_path__ + "static/img/uxuidesignmobile.5afe86c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/uxuidesignmobile.png
// module id = W4Ze
// module chunks = 0